define(function(e,i){"use strict";function t(e,i,t,o,n,r,d,l,c){this.model=e,this.utils=t,this.error=o,this.widget=i}t.$inject=["WidgetModel","lpWidget","lpCoreUtils","lpCoreError","NavigationService","AgencyHoldHandOffModel","AgencyReconHandOffModel","BrokerAccountSummaryModel","RegistrationHandOffModel"],i.MainCtrl=t});


// WEBPACK FOOTER //
// ./src/widget-hdfc-broker-services/scripts/controllers.js